import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

/**
 * Service to set, get, encrypt and decrypt local storage info.
 * @class DataStorageService
 */
@Injectable({
  providedIn: 'root',
})
export class DataStorageService {
  constructor() {}

  ENCRYPTION_KEY = '3062839577d408a8d928b3a3b4d358c1';
  ENCRYPTION_KEY_UTF = CryptoJS.enc.Utf8.parse(this.ENCRYPTION_KEY);
  IV = CryptoJS.enc.Base64.parse(this.ENCRYPTION_KEY);

  has(key: string): boolean {
    return this.get(key);
  }

  // updated has function cause the upper one is consumed bu multiple files
  hasKey(key: string): boolean {
    return localStorage.hasOwnProperty(this.encrypt(key));
  }

  set(key: string, value: any): void {
    localStorage.setItem(this.encrypt(key), this.encrypt(value));
  }

  get(key: string): any {
    return this.decrypt(localStorage.getItem(this.encrypt(key)));
  }

  remove(key: string): void {
    return localStorage.removeItem(this.encrypt(key));
  }

  clear(key: string): void {
    return localStorage.clear();
  }

  private encrypt(value: any): string {
    return value
      ? CryptoJS.AES.encrypt(value, this.ENCRYPTION_KEY_UTF, {
          iv: this.IV,
        }).toString()
      : '';
  }

  private decrypt(value: any): string {
    try {
      return value
        ? CryptoJS.enc.Utf8.stringify(
            CryptoJS.AES.decrypt(
              CryptoJS.lib.CipherParams.create({
                ciphertext: CryptoJS.enc.Base64.parse(value),
              }),
              this.ENCRYPTION_KEY_UTF,
              {
                iv: this.IV,
              }
            )
          )
        : '';
    } catch (e) {
      return '';
    }
  }

  clearAll(): void {
    localStorage.clear();
  }
}
